import styles from "./cartList.module.css";
import BoxCart from "./BoxCart";

import { useState } from "react";
import { AiFillLeftCircle } from "react-icons/ai";
import ShoppingCart from "./ShoppingCart";


const CartList = () => {
    const [selectedItem, setSelectedItem] = useState(1);
    const [customers, setCustomers] = useState([
      {
        name: "سارا محمود زاده",
        mobile: "09211086558",
        totalProduct: 8,
        totalItem: 8,
        price: 7,
        id: 0,
      },
      {
        name: "سارا محمود زاده",
        mobile: "09211086558",
        totalProduct: 8,
        totalItem: 8,
        price: 7,
        id: 1,
      },
      {
        name: "سارا محمود زاده",
        mobile: "09211086558",
        totalProduct: 8,
        totalItem: 8,
        price: 7,
        id: 2,
      },
      {
        name: "سارا محمود زاده",
        mobile: "09211086558",
        totalProduct: 8,
        totalItem: 8,
        price: 7,
        id: 3,
      },
      {
        name: "سارا محمود زاده",
        mobile: "09211086558",
        totalProduct: 8,
        totalItem: 8,
        price: 7,
        id: 4,
      },
      {
        name: "سارا محمود زاده",
        mobile: "09211086558",
        totalProduct: 8,
        totalItem: 8,
        price: 7,
        id: 5,
      },
    ]);
    return (
      <div className=" w-100 mt-2 ">
              <div className={`container ${styles.containShadow} `}>
              <div className="container w-100">
      {customers ? (
        customers.map((item, index) => {
          return (
            <div>
              <BoxCart
                item={item}
                key={item.id}
                customers={customers}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                setCustomers={setCustomers}
                index={index}
              />
            </div>
          );
        })
      ) : (
        <p>Loading...</p>
      )}

      <div className="d-flex justify-content-center mt-4">
        <AiFillLeftCircle className={styles.circl} />
      </div>
      <ShoppingCart
        index={selectedItem}
        customers={customers}
        EditUser={setCustomers}
      />
   
    </div>
              </div>
            </div>
    );
  };
  
  export default CartList;